import { Control, useController } from 'react-hook-form';
import RadioInput from '@components/common/radioInput';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import { AdditionInfoVO } from '@domain/vo/match/ResumeAdditionInfoVO';

import classnames from 'classnames/bind';
import styles from './additionalInputModal.module.scss';
const cx = classnames.bind(styles);

interface Props extends AdditionInfoVO {
  control: Control;
}

const SingleChoice = ({ additionInfoSn, question, choices, required, control }: Props) => {
  const {
    field,
    fieldState: { invalid },
    formState: { errors },
  } = useController({
    control,
    name: `${additionInfoSn}`,
  });

  return (
    <div>
      <h3 className={cx('formTitle')}>
        {question}
        <span className={cx('formSubTitle')}>(단일 선택)</span>
        {required && <span className={cx('require')}>필수</span>}
      </h3>

      <div className={cx('radioWrap')}>
        {choices.map((choice) => (
          <RadioInput
            key={choice}
            checked={field.value === choice}
            label={choice}
            name={field.name}
            value={choice}
            onChange={field.onChange}
          />
        ))}
      </div>

      {invalid && <ErrorMessage errors={errors} name={field.name} />}
    </div>
  );
};

export default SingleChoice;
